export default {"src":"/_next/static/media/world-map.aa8fd92d.gif","height":432,"width":812,"blurWidth":0,"blurHeight":0};